'use client';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { lighten } from '@mui/material/styles';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { PieChart } from 'echarts/charts';
import { GridComponent, PolarComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { type FC, useMemo } from 'react';
type Props = {
  data: {
    value: number;
    name: string;
  }[];
  color?: string;
  isBlury?: boolean;
  minHeigth?: string;
};

// Register the required components
echarts.use([TooltipComponent, GridComponent, PolarComponent, PieChart, SVGRenderer]);
export const Continuum: FC<Props> = (props: Props) => {
  const {
    data,
    isBlury = false,
    minHeigth = '350px'
  } = props;
  const theme = useTheme();
  const customData = useMemo(() => data.map(item => {
    const fakeValue = Math.floor(Math.random() * 101);
    const lightenOpacity = isBlury ? fakeValue / 100 : item.value / 100;
    const lightenRatio = 1 - lightenOpacity;
    return {
      value: isBlury ? fakeValue : item.value,
      name: item.name,
      itemStyle: {
        opacity: 1,
        color: lighten(theme.palette.primary.main, lightenRatio)
      }
    };
  }), [data, isBlury, theme]);
  const option = useMemo(() => ({
    // toolbox: {
    //   show: true,
    //   feature: {
    //     mark: { show: true },
    //     dataView: { show: true, readOnly: false },
    //     restore: { show: true },
    //     saveAsImage: { show: true },
    //   },
    // },
    grid: {
      top: 0,
      bottom: 0
    },
    tooltip: {
      show: true,
      axisPointer: {
        type: 'shadow'
      },
      valueFormatter: (value: string) => `${value}%`
    },
    polar: {
      show: false
    },
    radiusAxis: {
      min: 0,
      max: 100,
      interval: 10
    },
    angleAxis: {
      type: 'category',
      data: customData.map(item => item.name),
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        show: false
      }
    },
    series: [{
      type: 'bar',
      data: customData,
      coordinateSystem: 'polar',
      stack: 'Min Max',
      barCategoryGap: 0,
      itemStyle: {
        color: theme.palette.primary.main,
        borderRadius: 2
      },
      label: {
        show: false
      },
      labelLine: {
        show: false
      }
    }, {
      type: 'pie',
      colorBy: 'series',
      radius: ['-100%', '80%'],
      center: ['50%', '50%'],
      roseType: 'area',
      z: -1,
      silent: true,
      data: customData.map(d => ({
        ...d,
        name: `${d.name} (${d.value}%)`,
        value: 0
      })),
      // itemStyle: {
      //   color: theme.palette.primary.main,
      //   borderRadius: 2,
      // },
      label: {
        show: true,
        color: '#2D5B5B',
        opacity: 1,
        fontWeight: 'bold',
        position: 'outside'
      },
      labelLine: {
        show: true,
        lineStyle: {
          color: theme.palette.primary.main
        }
      },
      itemStyle: {
        borderRadius: 5,
        opacity: 0
      }
    }]
  }), [customData, theme]);
  return <Box component="div" width="100%" height={{
    none: minHeigth,
    sx: '600px'
  }} data-sentry-element="Box" data-sentry-component="Continuum" data-sentry-source-file="index.tsx">
      <ReactEChartsCore echarts={echarts} option={option} notMerge={true} lazyUpdate={true} theme={'theme_name'} style={{
      height: '100%',
      width: '100%'
    }} opts={{}} data-sentry-element="ReactEChartsCore" data-sentry-source-file="index.tsx" />
    </Box>;
};